<template>
  <div class="BottomText">
      <span>Copyright © 2020 Freightshop <a href="https://beian.miit.gov.cn/">粤ICP备14023066号-2</a></span>
      <a class="marL20" href="/Terms">Terms and Conditions</a>
      <em style="margin:0 5px;color:#d0d0d0">|</em>
      <a href="/privacy">Privacy Policy</a>
      <em style="margin:0 5px;color:#d0d0d0">|</em>
      <a href="/refund">Refund and Cancellation Policy</a>
      
  </div>
</template>

<script type="text/ecmascript-6">
    export default {
        components:{},

        data (){
            return {

            }
        },
        created(){

        },
        methods:{

        }
    }
</script>
<style type="text/css" rel="stylesheet" scoped="scoped">

.BottomText{position:absolute;bottom:0;text-align:center;width:100%;border-top:1px solid #ddd;height:60px;line-height:60px;z-index:8;}
.BottomText span{color:#999}
.BottomText a{color:#999}
.BottomText a:hover{color:#004FB1}

.fyFooter{background:#116ef9;border-top:1px solid #5899fa !important;}
.fyFooter span{color:#bcd6ff}
.fyFooter a{color:#bcd6ff !important;}
.fyFooter a:hover{color:#fff !important;}



</style>



// WEBPACK FOOTER //
// src/components/reception/public/footerInfo.vue